import React from 'react'
import DoneAllOutlinedIcon from '@mui/icons-material/DoneAllOutlined'

import Button from 'components/Form/Button'
import NotificationListItem from 'components/Notifications/NotificationListItem'
import NotificationListSkeleton from 'components/Notifications/NotificationListSkeleton'
import NotificationState from 'components/Notifications/NotificationState'
import useController from './controller'
import {
    ListAction,
    ListHeader,
    ListHeadingGroup,
    ListMeta,
    ListSection,
    ListTitle,
    NotificationList,
    Page,
    PageEyebrow,
    PageHeader,
    PageIntro,
    PageSubtitle,
    PageTitle,
} from './styled'

export default function Notifications() {
    const {
        notifications,
        unreadCount,
        loading,
        loaded,
        error,
        markingAll,
        retry,
        openNotification,
        markAllRead,
        t,
    } = useController()

    return (
        <Page>
            <PageHeader>
                <PageIntro>
                    <PageEyebrow>MagVenture Universe</PageEyebrow>
                    <PageTitle>{t('notifications')}</PageTitle>
                    <PageSubtitle>{t('notifications_subtitle')}</PageSubtitle>
                </PageIntro>
            </PageHeader>

            <ListSection>
                <ListHeader>
                    <ListHeadingGroup>
                        <ListTitle>{t('recent_activity')}</ListTitle>
                        <ListMeta>
                            {unreadCount
                                ? `${unreadCount} ${t(unreadCount === 1 ? 'unread_notification' : 'unread_notifications')}`
                                : t('notifications_all_read')}
                        </ListMeta>
                    </ListHeadingGroup>

                    {unreadCount ? (
                        <ListAction>
                            <Button
                                color="blue"
                                disabled={markingAll}
                                loading={markingAll}
                                nospace
                                outline
                                small
                                startIcon={<DoneAllOutlinedIcon />}
                                width="fit-content"
                                onClick={markAllRead}
                            >
                                {t('mark_all_notifications_read')}
                            </Button>
                        </ListAction>
                    ) : null}
                </ListHeader>

                {!loaded || (loading && !notifications.length) ? (
                    <NotificationListSkeleton label={t('loading_notifications')} />
                ) : error && !notifications.length ? (
                    <NotificationState
                        actionLabel={t('try_again')}
                        description={t('notifications_load_error_description')}
                        onAction={retry}
                        title={t('notifications_load_error')}
                    />
                ) : notifications.length ? (
                    <NotificationList aria-label={t('notifications')}>
                        {notifications.map(notification => (
                            <NotificationListItem
                                key={notification.id}
                                notification={notification}
                                onClick={openNotification}
                                unreadLabel={t('unread')}
                            />
                        ))}
                    </NotificationList>
                ) : (
                    <NotificationState
                        description={t('notifications_empty_description')}
                        title={t('notifications_empty')}
                    />
                )}
            </ListSection>
        </Page>
    )
}
